document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.meals-section');

    sections.forEach(section => {
        const container = section.querySelector('.meals-marquee');
        const track = section.querySelector('.meals-track');
        const dots = section.querySelectorAll('.nav-dot');

        if (!container || !track) return;

        // State
        let state = {
            isDown: false,
            startX: 0,
            scrollLeft: 0,
            autoScrollSpeed: 0.5, // slightly increased from 0.3 for visibility, can tune
            autoScrollActive: true,
            preciseScroll: container.scrollLeft // Accumulator for subpixel precision
        };

        let timeoutId;
        let animationId;

        // --- Helpers ---
        const getSingleSetWidth = () => container.scrollWidth / 2;

        const setSnap = (enabled) => {
            if (enabled) {
                container.style.scrollSnapType = 'x mandatory';
                container.style.scrollBehavior = 'smooth';
            } else {
                container.style.scrollSnapType = 'none';
                container.style.scrollBehavior = 'auto';
            }
        };

        // --- Dots Logic ---
        const updateDots = () => {
            const setWidth = getSingleSetWidth();
            if (setWidth <= 0) return;

            const currentScroll = container.scrollLeft % setWidth;
            const totalItems = dots.length;
            const itemWidth = setWidth / totalItems;
            const activeIndex = Math.round(currentScroll / itemWidth) % totalItems;

            dots.forEach((dot, index) => {
                if (index === activeIndex) dot.classList.add('active');
                else dot.classList.remove('active');
            });
        };

        dots.forEach(dot => {
            dot.addEventListener('click', (e) => {
                e.preventDefault();
                // Pause interaction
                stopAutoScroll();
                setSnap(true); // Enable snap for smooth scroll to target

                const index = parseInt(dot.getAttribute('data-slide'));
                const setWidth = getSingleSetWidth();
                const totalItems = dots.length;
                const itemWidth = setWidth / totalItems;

                container.scrollTo({
                    left: (itemWidth * index),
                    behavior: 'smooth'
                });

                // Resume after delay
                resetAutoScrollTimer(4000);
            });
        });

        // --- State Management ---
        const stopAutoScroll = () => {
            state.autoScrollActive = false;
            cancelAnimationFrame(animationId);
            if (timeoutId) clearTimeout(timeoutId);
        };

        const resetAutoScrollTimer = (delay = 2000) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                state.autoScrollActive = true;
                // Important: Disable snap before restarting loop for smooth drift
                setSnap(false);
                state.preciseScroll = container.scrollLeft; // Sync accumulator
                loop();
            }, delay);
        };

        // --- Drag Logic ---
        container.addEventListener('mousedown', (e) => {
            state.isDown = true;
            container.classList.add('active');
            container.style.cursor = 'grabbing';
            container.style.userSelect = 'none';
            setSnap(false); // Disable snap for direct control

            state.startX = e.pageX - container.offsetLeft;
            state.scrollLeft = container.scrollLeft;

            stopAutoScroll();
        });

        container.addEventListener('mouseleave', () => { if (state.isDown) stopDragging(); });
        container.addEventListener('mouseup', stopDragging);

        container.addEventListener('mousemove', (e) => {
            if (!state.isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - state.startX) * 2;
            container.scrollLeft = state.scrollLeft - walk;
        });

        // --- Touch Logic ---
        container.addEventListener('touchstart', () => {
            stopAutoScroll();
            // setSnap(false); // Disable snapping initially on touch for fluid tracking? 
            // Actually, for native swipe, we usually *want* native behavior.
            // But we paused auto-scroll, so native scroll takes over.
        }, { passive: true });

        container.addEventListener('touchend', () => {
            // Resume later
            resetAutoScrollTimer(3000);
            // Re-enable snap to catch the card
            setSnap(true); // Ensure snap is on for the finish
        });

        function stopDragging() {
            state.isDown = false;
            container.classList.remove('active');
            container.style.cursor = 'grab';
            container.style.removeProperty('user-select');

            setSnap(true); // Snap to nearest card
            resetAutoScrollTimer(2000);
        }

        // --- Infinite Loop Logic ---
        function loop() {
            if (!state.autoScrollActive || state.isDown) return;

            // 1. Move
            state.preciseScroll += state.autoScrollSpeed;
            container.scrollLeft = state.preciseScroll;

            // 2. Wrap Check
            const maxScroll = container.scrollWidth / 2;

            // Safety check for not-yet-loaded
            if (maxScroll <= 0) {
                animationId = requestAnimationFrame(loop);
                return;
            }

            if (container.scrollLeft >= maxScroll) {
                // Wrap back to 0 (or technically start of set A)
                // We subtract maxScroll from preciseScroll to maintain smoothness
                state.preciseScroll -= maxScroll;
                container.scrollLeft = state.preciseScroll;
            }
            else if (container.scrollLeft <= 0) {
                // Should rarely happen in auto-scroll, but good for robustness
                state.preciseScroll += maxScroll;
                container.scrollLeft = state.preciseScroll;
            }

            updateDots();

            // 3. Next Frame
            animationId = requestAnimationFrame(loop);
        }

        // --- Init ---
        // Force snap OFF initially for auto-scroll
        setSnap(false);
        state.preciseScroll = container.scrollLeft;
        loop();

        // Listen to native scroll to update dots even when auto-scroll is paused (e.g. during drag)
        container.addEventListener('scroll', () => {
            if (!state.autoScrollActive) updateDots();
        });
    });
});
